import React from "react";
import { NavigationDots, SocialMedia } from "../components";
import { IoDocumentTextOutline } from "react-icons/io5";

const AppWrap = (Component, idName, classNames) =>
  function HOC() {
    return (
      <div id={idName} className={`app__container ${classNames}`}>
        <SocialMedia />
        <div className="app__wrapper app__flex">
          <Component />

          <div className="copyright">
            <p className="p-text">Get My Resume</p>

            <p className="p-text-center">
              <a
                href="https://drive.google.com/file/d/1F6ZgxfgUaxH7Q1mU_smDXJBqMILF6tCv/view?usp=sharing"
                target="_blank"
              >
                <IoDocumentTextOutline style={{ color: "blue" }} />
              </a>
            </p>
          </div>
        </div>
        <NavigationDots active={idName} />
      </div>
    );
  };

export default AppWrap;
